module.exports = __webpack_public_path__ + "img/bg_kinerja_keuangan_end.02fe0bab.png";